// SampleUserMetadata.tsx
import { DetailSection, MetaField, MetaGrid } from '@/components/DetailPage';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

// TODO(backend): no user-metadata field exists on any sample model. This section is a
// static stub awaiting backend support + edit capability (see Balsamiq sticky note).
function SampleUserMetadataComponent() {
  const { t } = useTranslation('studies');
  const empty = t('empty', { ns: 'general' });

  return (
    <DetailSection data-testid="sample-user-metadata" title={t('samples.details.userMetadataHeading')}>
      <MetaGrid columns={3}>
        <MetaField label={t('samples.details.userMetaGender')} placeholder={empty} value={undefined} />
        <MetaField label={t('samples.details.userMetaHeight')} placeholder={empty} value={undefined} />
        <MetaField label={t('samples.details.userMetaIris')} placeholder={empty} value={undefined} />
      </MetaGrid>
    </DetailSection>
  );
}

export const SampleUserMetadata = memo(SampleUserMetadataComponent);
